export default function InputField({ label, type, value, onChange, name, required = true, ...props }) {
  return (
    <div className="mb-5 flex flex-col justify-start">
      <label className="block text-sm font-semibold text-secondary-700 mb-2 ml-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="w-full px-4 py-3 border border-secondary-200 rounded-xl bg-secondary-50 text-secondary-900 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all shadow-sm"
        {...props}
      />
    </div>
  );
}
